import { configureStore } from '@reduxjs/toolkit';
import rootReducer from './rootReducer';

// redux-logger 는 액션마다 prev state / action / next state 를 통째로 콘솔에 찍는다.
// 운영에서 켜두면 학생·학부모 연락처 같은 개인정보가 브라우저 콘솔에 그대로 남고
// (화면 공유나 원격 지원 때 노출된다), 상태가 커질수록 직렬화 비용도 든다.
//
// process.env.NODE_ENV 는 빌드 시 문자열로 치환되므로, 운영 번들에서는 아래 분기와
// require 가 통째로 제거되어 redux-logger 자체가 포함되지 않는다.
const middleware = (getDefaultMiddleware) => {
  if (process.env.NODE_ENV === 'production') {
    return getDefaultMiddleware();
  }
  const logger = require('redux-logger').default;
  return getDefaultMiddleware().concat(logger);
};

const store = configureStore({
  reducer: rootReducer,
  middleware,
});

export default store;
